;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.SidebarBuilder = Backbone.Model.extend({
		defaults: {
			widgets: [ 'MenuSideBar' ],
			menuItems: [
				{ name: 'Prizes', url: 'help/prizes', status: ''},
				{ name: 'Game Rules', url: 'help/game-rules', status: ''},
				{ name: 'FAQs', url: 'help/faqs', status: ''},
				{ name: 'Terms and Conditions', url: 'help/terms', status: ''},
				{ name: 'Contact Us', url: 'help/contact-us', status: ''}
			]
		},
		initialize: function(){
			this.extendDefaults()
				.setActiveState();
		},
		extendDefaults() {
			return this;
		},
		setActiveState: function(){
			var current_url = Backbone.history.fragment,
				currentMenuItems = this.get('menuItems');

			if ( current_url == 'help' ) {
				current_url = 'help/terms';
				if (CONFIG.OFF_SEASON) {
					current_url = 'off-season' + current_url;
				}
				
			}
			_.each(currentMenuItems, function(value, key){
				value.status = '';
				if(current_url == value.url){
					currentMenuItems[key].status = 'active'
				}
			});
			this.set('menuItems',currentMenuItems );
		}
	});

}(window, APP, Backbone, Marionette, $, _));